import { http } from './../utility/http.js'
import { formattedDate } from './../utility/helper.js'

const container = document.querySelector('.posts')
const filters = document.querySelectorAll('.category-filter');
const resetFilters = document.querySelector('.clear-filters');
const urlParams = new URLSearchParams(window.location.search);
const value = parseInt(urlParams.get('cat'))

var sitePath = '/'
if (container) {
	sitePath = container.getAttribute('data-sitepath')
}

const api = sitePath + `wp-json/wp/v2/articles?orderby=date&order=desc&acf_format=standard`
var termArray = [] // create empty array
var currentPage = 1 
var loadedPage = 0 
var totalPages = 1
var categories = []

function filterPosts() {
	var termID = parseInt(this.getAttribute('data-term'));
	const exists = termArray.includes(termID)
	currentPage = 1 

	if (!exists) {
		termArray.push(termID)
		this.classList.add('active')
	} else {
		var index = termArray.indexOf(termID);
		this.classList.remove('active')
		if (index !== -1) {
			termArray.splice(index, 1);
		}
	}

	categories = termArray.join(",");
	if (categories.length) {
		getPosts({
			query: { categories: categories },
		})
	} else {
		getPosts({})
	}

	if (categories.length) {
		resetFilters.classList.add('active')
	} else {
		resetFilters.classList.remove('active')
	}
	
}

function clearFilters() {
	categories = [] //reset array
	termArray = []
	currentPage = 1
	loadedPage = 0
	
	resetFilters.classList.remove('active')
	filters.forEach((el) => {
		el.classList.remove('active')
	});

	getPosts({
		pages: { page: currentPage },
	})
}
 
function getPosts({ url = api, query = {}, per_page = 6, page = 1, clearDom = true} ) {
	var params = new URLSearchParams({
		...query, 
		per_page, 
		page
	})
	
	http({
		url: `${url}&${params.toString()}`,
		success: (response, xhr) => {
			var posts = JSON.parse(response)
			totalPages = parseInt(xhr.getResponseHeader('x-wp-totalpages'))
			loadedPage = page
			renderPosts(container, posts, clearDom)
			renderLoadTrigger()	
		}
	})
}

function loadPosts() {
	if (loadedPage !== currentPage) return
	if (currentPage >= totalPages ) return

	currentPage = currentPage + 1;

	if (categories.length) {
		getPosts({
			query: { categories: categories },
			page: currentPage,
			clearDom: false
		})
	} else {
		getPosts({
			page: currentPage,
			clearDom: false
		})
	}
}

function renderPosts(container, posts, clearDom = true) { // add true / false to hide the clear
	if (!container) return
	const fragment = document.createDocumentFragment()

	

    posts.map(post => {
		const template = renderPost(post)
		
		const element = document.createElement('div')
		element.innerHTML = template
		fragment.appendChild(element.firstElementChild)
	}) 

	if (clearDom) {
		container.innerHTML = "";
	}
	container.appendChild(fragment)
}

function articleType(format) {
    if (format === 'video') {
        return `<div><img src="/wp-content/themes/vodafone/assets/img/video-icon.svg"></div>`
    } else if (format === 'blog') {
        return `<div><img src="/wp-content/themes/vodafone/assets/img/article-icon.svg"></div>`
    } 
    return ``
}

function renderPost(post) {
	const x = post.acf.featured_image.x || '50' 
	const y = post.acf.featured_image.y || '50'

	const html = `
		<div class="single-card col-4@medium col-6@small">
			<div class="card__inner box-shadow bg--white">
				<a href="${post.link}">
					${post.acf.featured_image?.sizes?.large && `
						<div class="card__image relative">
							<img 
								class="object-fit--absolute" 
								src="${post.acf.featured_image.sizes.large}" 
								style="object-position:${x}% ${y}%;
							">
						</div>
					` || '' }
					<div class="card__content">
						<div class="first-last">
							<div class="grid space-between">
								<p class="text-small margin-top-0">${formattedDate(post.date)} | ${post.acf.article_type.label}</p>
								${articleType(post.acf.article_type.value)}
							</div>
							<div class="first-last">
								<h4 class="heading-5">
									<span>${post.title.rendered}<div class="card__icon"></div></span>
								</h4>
								<p>${post.excerpt}</p>
							</div>
							
						</div>
					</div>
				</a>
			</div>
		</div>
	`

	return html
}

function renderLoadTrigger() {
	const loading = document.querySelector('.loading')
	if (!loading) return

	const loadPosts = `<div id="test" class="load-posts"></div>`
	const noPosts = `<div class="no-posts"><h4 class="heading-5 margin-top-4">No more posts to display</h4></div>`

	if (currentPage < totalPages ) {
		loading.innerHTML = loadPosts
	} else {
		loading.innerHTML = noPosts
	}
}

function intersector() {
	const loading = document.querySelector(".loading")
	if (!loading) return
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			loadPosts()
		})
	  }, { threshold: 1 })
	  
	  observer.observe(loading)
}

if (filters) {
	filters.forEach(function(el) {
		el.addEventListener('click', filterPosts);
	});

	filters.forEach(el =>  {
		var termID = parseInt(el.getAttribute('data-term'));

		if (termID === value) {
			el.classList.add('active')
			resetFilters.classList.add('active')
		}
	})
}

if (resetFilters) {
	resetFilters.addEventListener('click', clearFilters);
}

if (value) {
	getPosts({ query: { categories: value } })
} else {
	getPosts({})
}



intersector()

